import { getLabelFromOptionValue } from '../../configuration/utilities'
import moment from 'moment'

/*
  NOTE(ebarrett):
    Passenger fields have a lot variability depending on client and route,
    and unfortunately the layout needs to be explicitly defined (Formik doesn't
    have hints about laying fields out intelligently).

    We were encountering some bugs using the `keysToRemove` approach for pulling
    items out of the layout. I've tried to capture the rules in a more
    straight-forward manner here below. Please update the rules if additional fields
    are added 

    1. MAI does not show accessibility fields
    2. Only CAT collects passport fields
    3. Only BFL collects dateOfBirth [without passport]

    So this gives us the following layouts...
      - Default layout (fallback)
      - MAI layout
      - CAT layout
      - BFL layout
*/

// const whenAccessibility = { when: { accessibility: true } }
const dateFormatTest = value =>
  value?.length === process.env.REACT_APP_FORCE_DOB_FORMAT?.length &&
  moment(value, process.env.REACT_APP_FORCE_DOB_FORMAT).isValid()

function getDefaultLayout() {
  return {
    fieldNames: [
      'type', // Used to build labels for form
      'passengerType', // Used to build labels for form
      'firstName',
      'lastName',
      'gender',
      'accessibility'
      // 'accessibilityTextField'
    ],
    mainLayout: [['firstName', 'lastName', 'gender'], ['accessibility']],
    optionalLayout: [
      /* ['accessibilityTextField'] */
    ],
    conditionallyIncludedRequiredFields: {
      /* accessibilityTextField: whenAccessibility */
    },
    conditionalTests: {}
  }
}

function getMAILayout() {
  return {
    fieldNames: [
      'type', // Used to build labels for form
      'passengerType', // Used to build labels for form
      'firstName',
      'lastName',
      'gender'
    ],
    mainLayout: [['firstName', 'lastName', 'gender']],
    optionalLayout: [],
    conditionallyIncludedRequiredFields: {},
    conditionalTests: {}
  }
}

function getCATLayout() {
  return {
    fieldNames: [
      'type', // Used to build labels for form
      'passengerType', // Used to build labels for form
      'firstName',
      'lastName',
      'gender',
      'citizenship',
      'typeOfId',
      'passport',
      'passportConfirm',
      'passportExpiryDate',
      'passportIssueCountry',
      'dateOfBirth',
      'accessibility'
      // 'accessibilityTextField'
    ],
    mainLayout: [
      ['firstName', 'lastName', 'gender', 'citizenship'],
      ['typeOfId', 'passport', 'passportConfirm'],
      ['passportIssueCountry', 'passportExpiryDate', 'dateOfBirth'],
      ['accessibility']
    ],
    optionalLayout: [
      /* ['accessibilityTextField'] */
    ],
    conditionallyIncludedRequiredFields: {
      /* accessibilityTextField: whenAccessibility */
    },
    conditionalTests: {
      dateOfBirth: dateFormatTest,
      passportExpiryDate: dateFormatTest
    }
  }
}

function getBFLLayout() {
  return {
    fieldNames: [
      'type', // Used to build labels for form
      'passengerType', // Used to build labels for form
      'firstName',
      'lastName',
      'accessibility'
      // 'accessibilityTextField'
    ],
    mainLayout: [['firstName', 'lastName'], ['accessibility']],
    optionalLayout: [
      /* ['accessibilityTextField'] */
    ],
    conditionallyIncludedRequiredFields: {
      /* accessibilityTextField: whenAccessibility */
    },
    conditionalTests: {
      dateOfBirth: dateFormatTest
    }
  }
}

function getNFLLayout() {
  return {
    fieldNames: [
      'type', // Used to build labels for form
      'passengerType', // Used to build labels for form
      'firstName',
      'lastName',
      'accessibility'
      // 'accessibilityTextField'
    ],
    mainLayout: [['firstName', 'lastName'], ['accessibility']],
    optionalLayout: [
      /* ['accessibilityTextField'] */
    ],
    conditionallyIncludedRequiredFields: {
      /* accessibilityTextField: whenAccessibility */
    },
    conditionalTests: {}
  }
}

export const getFieldsAndLayout = ({ paymentFerryId }) => {
  const clientId = process.env.REACT_APP_FLOW_CLIENT_ID

  switch (clientId) {
    case 'nfl':
      switch (paymentFerryId) {
        case 'cat':
          return getCATLayout()
        case 'bfl':
          return getBFLLayout()
        case 'nfl':
          return getNFLLayout()
        default:
          return getDefaultLayout()
      }
    case 'mai':
      return getMAILayout()
    default:
      return getDefaultLayout()
  }
}

export const getPassengerLabel = ({
  fieldDetails,
  passenger,
  duplicateQuantities,
  labels
}) => {
  const passengerType = getLabelFromOptionValue(
    passenger?.passengerType,
    fieldDetails?.passengerType?.options
  )
  let tripTypePrefix

  if (passenger?.type) {
    if (passenger.type === 'departures' && labels.departureRoute) {
      tripTypePrefix = labels.departureRoute
    }
    if (passenger.type === 'returns' && labels.returnRoute) {
      tripTypePrefix = labels.returnRoute
    }
  }

  return tripTypePrefix && passengerType
    ? `${tripTypePrefix} - ${passengerType}`
    : ''
}

export const EDLAcceptedStates = [
  'Michigan',
  'Minnesota',
  'New York',
  'Vermont ',
  'Washington State'
]
